<script setup lang="ts">
// The screen renders at a real phone size and is scaled to the frame, so
// product components keep their real proportions at any frame width.
import { useElementSize } from '@vueuse/core'

const SCREEN = { width: 360, height: 760 }

const screen = useTemplateRef<HTMLElement>('screen')
const { width, height } = useElementSize(screen)
const scale = computed(() => width.value ? Math.max(width.value / SCREEN.width, height.value / SCREEN.height) : 0)
</script>

<template>
  <div class="relative aspect-[360/760] w-full rounded-[2.75rem] border-[6px] border-neutral-900 bg-neutral-900 shadow-2xl">
    <div ref="screen" class="relative size-full overflow-hidden rounded-[2.3rem] bg-background text-left text-foreground">
      <div
        class="absolute left-1/2 top-0 origin-top"
        :class="scale ? '' : 'invisible'"
        :style="{ width: `${SCREEN.width}px`, height: `${SCREEN.height}px`, transform: `translateX(-50%) scale(${scale})` }"
      >
        <slot />
      </div>
      <div class="pointer-events-none absolute left-1/2 top-[1.5%] z-20 h-[3.5%] w-[30%] -translate-x-1/2 rounded-full bg-neutral-900" />
    </div>
  </div>
</template>
